export default __webpack_public_path__ + "static/media/login-background.078b06a3.png";